


export class PublicationsInfoView {

    constructor() {

        this.id = 'info-violity';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			
			//throw new Error('#' + id + ' element missing');
			return false;
		}
		
		this.title = this.box.querySelector('.sc_title > strong');
		
		this.ul = this.box.querySelector('.ul');
		
		this.itemTemplate = this.ul.querySelector('.li')?.cloneNode(true);
    }

    render(state) { 

        if (!this.box) { return false;}
		
		if (state.title) { this.title.textContent = state.title;}
		
		if (state.data) {
			
			const dummies = this.ul.querySelectorAll('.dummy');
			dummies.forEach((el, index) => {
				
				const data = state.data[index];

				if (!data) {
					el.parentElement.remove();
					return;
				}
				
				el.dataset.id = data.id;
				
				const titleLink = el.querySelector('.title > a');
				titleLink.href = data.url;
				
				titleLink.textContent = data.title;
				
				el.querySelector('.date').textContent = data.date;

				el.classList.remove('dummy');
			});

			this.ul.querySelectorAll('.li').forEach((li) => {
				if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
			});
			
			this.box.style.display = (this.ul.querySelector('.li')) ? '' : 'none';
			
			this.box.classList.remove('dummy');
		}
    }
}